import { useState } from "react";
import { Link } from "react-router-dom";
import { Loader2 } from "lucide-react";
import AuthShell from "@/pages/auth/AuthShell";
import { useI18n } from "@/context/I18nContext";
import api, { apiError } from "@/lib/api";
import { toast } from "sonner";

export default function ForgotPassword() {
  const { t } = useI18n();
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try { const { data } = await api.post("/auth/forgot-password", { email }); toast.success(data.message); setSent(true); }
    catch (e2) { toast.error(apiError(e2)); }
    setLoading(false);
  };

  return (
    <AuthShell title={t("auth.forgotTitle")} subtitle={t("auth.forgotSub")}
      footer={<Link to="/login" className="text-amber-400 font-semibold">{t("auth.signin")}</Link>}>
      {sent ? (
        <div className="rounded-lg bg-emerald-500/10 border border-emerald-500/30 text-emerald-300 text-sm px-4 py-4" data-testid="forgot-sent">
          If an account exists for {email}, a reset link has been sent. Check your inbox.
        </div>
      ) : (
        <form onSubmit={submit} className="space-y-4" data-testid="forgot-form">
          <div><label className="label-lux">{t("auth.email")}</label><input required type="email" className="input-lux mt-2" value={email} onChange={(e) => setEmail(e.target.value)} data-testid="forgot-email-input" /></div>
          <button disabled={loading} className="gold-btn w-full" data-testid="forgot-submit-btn">{loading ? <Loader2 className="animate-spin" size={18} /> : t("auth.sendReset")}</button>
        </form>
      )}
    </AuthShell>
  );
}
